import { Component, OnInit } from '@angular/core';
import { LoginService } from "app/login/login.service";
import { AccountService } from "app/account/account.service";
import { LookupService } from "app/webservice/lookup.service";
import { Router } from "@angular/router";
import { ToastsManager } from "ng2-toastr";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public loginDetails = {
    "AuthenticationRequest": {
      "ApplicationName": "CCLibrary",
      "LoginName": "",
      "Password": "",
      "EncryptionType": "",
      "Remember": false
    }
  };

  public loggedIn: boolean = false;

  constructor(
    private _loginService: LoginService,
    private _accountService: AccountService,
    private _router: Router,
    private _lookupService: LookupService,
    private _toast: ToastsManager
  ) {

  }

  ngOnInit() {
  }


  login() {
    this.loggedIn = true;
    console.log("logging in");
    this._loginService.login(this.loginDetails)
      .then((res) => {
        this.loginDetails.AuthenticationRequest.LoginName = '';
        this.loginDetails.AuthenticationRequest.Password = '';
        this.loginDetails.AuthenticationRequest.Remember = false;

        console.log(res);
        if (res.PayloadResponse) {
          this._accountService.updateAuthToken(res.PayloadResponse.AuthToken);
          this._loginService.loadInitialUrl(res.PayloadResponse.InitialPayloadURL, {})
            .then((res) => {
              this.loggedIn = false;
              if (res.Payload) {
                this._accountService.updateAccount(res.Payload.UserInfo);
                this._lookupService.updateLookups(res.Payload.Lookups);
                this._router.navigate(['/media/search']);
              } else {
                this._toast.error('No payload found for user.');
              }
            }).catch((err) => {
              console.log(err);
              this._toast.error('Error loading application for user.');
              this.loggedIn = false;
            })
        } else {
          this._toast.error('Error logging in.');
          this.loggedIn = false;
        }
      }).catch((err) => {
        console.log(err);
        this._toast.error('Error logging in');
        this.loggedIn = false;
        this.loginDetails.AuthenticationRequest.LoginName = '';
        this.loginDetails.AuthenticationRequest.Password = '';
        this.loginDetails.AuthenticationRequest.Remember = false;
      });
  }

}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/login/login.component.ts